import React, {useState, useEffect} from "react";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Image,
  Input,
  Row,
  Space,
  Spin,
  Typography,
} from "antd";

import "./Login.scss";
import {useNavigate} from "react-router-dom";

import {authenticationService} from "api";
import {data} from "data/env";
import {Notification} from "components/common";
import {checkTokenValidity, refreshTokenNoNotification} from "helper/auth";
import {useAppDispatch} from "redux/hooks";
import Icon from "assets/icons";
import {
  fetchExamServiceCategory,
  fetchSourcePatient,
  getDoiTuong,
  getListHinhThucThanhToan,
  getListKhuKham,
  getListLoaiKCB,
  getListPhongKham,
  getListProvince,
  getListQuyCach,
  getListTTBH,
  getListTTKCB,
  getListTrangThaiCSKH,
  getListTrangThaiPhauThuat,
  getListTrangThaiPhieu,
  getListTrangThaiTraThuoc,
  getListUnitAPI,
} from "helper/call-api-list";
import {getIcdList, getListCommune} from "helper/api";
import {setSiderKey, setUserRoles} from "redux/reducer/common";
import {jsonParse, toArray} from "helper/common";
const Login = props => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const callApiList = () => {
    getListCommune();
    getIcdList();
    getListLoaiKCB();
    getListKhuKham();
    getListTTBH();
    getListTrangThaiPhieu();
    getListPhongKham();
    getListTrangThaiPhauThuat();
    getListTrangThaiCSKH();
    getListUnitAPI();
    getDoiTuong();
    fetchSourcePatient();
    getListTrangThaiTraThuoc();
    getListCommune();
    getListProvince();
    getListQuyCach();
    getListHinhThucThanhToan();
    fetchExamServiceCategory();
    getListTTKCB();
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    const valid = checkTokenValidity(token);

    if (valid) {
      callApiList();
      navigate("/tiep-nhan");
      // dispatch(setSiderKey("tiep-nhan"));
    }
  }, []);

  const onFinish = async values => {
    try {
      const callbackUrl = data.client_callback_url;
      const params = {...values, callbackUrl: callbackUrl};
      const res = await authenticationService.login(params);
      setLoading(true);
      if (res.code == 200) {
        if (toArray(res.data.roles)?.length == 0) {
          Notification(
            "warning",
            "Tài khoản chưa được phân quyền. Vui lòng liên hệ quản trị viện"
          );
        } else {
          Notification("success", "Đăng nhập thành công");
          localStorage.setItem("token", res.data.accessToken);
          localStorage.setItem("refreshToken", res.data.refreshToken);
          localStorage.setItem("username", res.data.username);
          localStorage.setItem("idToken", res.data.idToken);
          localStorage.setItem("firstName", res.data.firstName);
          localStorage.setItem("lastName", res.data.lastName);
          localStorage.setItem("roles", res.data.roles);

          dispatch(setUserRoles(res.data.roles));
          localStorage.setItem(
            "fullName",
            res.data.lastName +
              `${res.data.lastName != "" ? " " : ""}` +
              res.data.firstName
          );
          const listMenu = res?.data?.roleMenuDtos?.map(e => {
            return e?.menu;
          });
          let listTab = [];
          for (let x of toArray(res.data?.roleTabDtos)) {
            if (Array.isArray(jsonParse(x.tab))) {
              listTab.push(...toArray(jsonParse(x.tab)));
            }
          }
          // console.log(JSON.stringify(listTab));
          localStorage.setItem("listTab", JSON.stringify(listTab));
          localStorage.setItem("listMenu", JSON.stringify(listMenu));
          callApiList();
          navigate("/tiep-nhan");
          console.log(res?.data?.roleTabDtos);
        }

        setLoading(false);
      } else {
        Notification("error", "Đăng nhập thất bại");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  return (
    <Spin spinning={loading}>
      <div className="Login">
        <Form
          form={form}
          layout="vertical"
          requiredMark={false}
          onFinish={onFinish}
        >
          <Row align={"middle"} justify={"center"} className="main">
            <Col
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                height: "100%",
              }}
            >
              <Space
                style={{width: "466px", height: "100%"}}
                direction="vertical"
                align="center"
                size={"small"}
              >
                <Row align={"middle"} justify={"center"}>
                  <div className="login-title">Đăng Nhập</div>
                </Row>
                <Row justify={"center"}>
                  <Typography.Text
                    className="login-description"
                    type="secondary"
                  >
                    Chào mừng bạn đến với hệ thống bệnh viện Alina
                  </Typography.Text>
                </Row>

                <Form.Item
                  name="username"
                  rules={[
                    {required: true, message: "Vui lòng nhập tên đăng nhập!"},
                  ]}
                >
                  <Input placeholder="Tên đăng nhập" />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[{required: true, message: "Vui lòng nhập mật khẩu!"}]}
                >
                  <Input.Password placeholder="Mật khẩu" />
                </Form.Item>

                <Row>
                  <Button
                    type="primary"
                    className="login-btn btn-sub"
                    htmlType="submit"
                  >
                    Đăng nhập
                  </Button>
                </Row>

                <Button
                  type="primary"
                  className="login-btn "
                  htmlType="submit"
                  onClick={() => {
                    window.location.replace(window.REACT_APP_USER_URL);
                  }}
                >
                  Cập nhật mật khẩu
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>
    </Spin>
  );
};

export default Login;
function navigate(arg0: string) {
  throw new Error("Function not implemented.");
}
